import { render } from "./Tal_commonBookTitle.vue?vue&type=template&id=56bf7014"
import script from "./Tal_commonBookTitle.vue?vue&type=script&lang=js"
export * from "./Tal_commonBookTitle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__